const axios = require('axios')

const api = axios.create({
    baseURL: `${process.env.VUE_APP_SERVICE_CATALOG}`
})

export default api
